import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { calculateCommission } from '@snapbrains/snapav/src/avantlink';

export default function Commision(props) {
  const { result } = props;
  const isLoaded = !!result;
  const commission = isLoaded ? calculateCommission(result) : '';
  const dollarSign = commission.indexOf('$') >= 0 ? '' : '$';
  const asbestos = '#7f8c8d';

  if (!isLoaded) {
    return (
      <div>
        <Skeleton style={{ width: 300 }} />
      </div>
    );
  }

  if (result.strActionCommission || result.commission) {
    return (
      <div style={{ fontSize: '0.7em', color: asbestos, margin: '0.3em' }}>
        Commission:
        {' '}
        <span>
          {result.strActionCommission}
          {' '}
          (
          {dollarSign}
          {commission}
          )
        </span>
      </div>
    );
  }
  return null;
}

Commision.propTypes = {
  result: PropTypes.shape({
    strActionCommission: PropTypes.string,
    commission: PropTypes.number,
  }).isRequired,
};
